import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import BigScreenEvent from '@/assets/images/presentation/big-screen.png';
import EventPreview from '@/assets/images/presentation/event-preview.png';

import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const PresentationAV = () => {
  const { t } = useTranslation();

  return (
    <Container mb={12}>
      <Flex textAlign="center" flexDirection="column" alignItems="center" margin="auto" pt={18} maxW="800px">
        <Text fontSize="3xl" fontFamily="heading">
          <Text as="span" fontSize="3xl" fontFamily="heading" fontWeight="bold">
            {t('newEventPage.avHeadingPartOne')}
          </Text>{' '}
          {t('newEventPage.avHeadingPartTwo')}
        </Text>
        <Text maxW="600px" my={8}>
          {t('newEventPage.avDescription')}
        </Text>
        <Link href="/events/audio-visual-service">
          <Button colorScheme="black">{t('newEventPage.avButtonLabel')}</Button>
        </Link>
        <Text fontFamily="heading" fontSize="3xl" mt={12}>
          {t('newEventPage.extendingYourConference')}
        </Text>
        <Text fontFamily="heading" mb={8} fontSize="3xl" fontWeight="bold">
          {t('newEventPage.engagingCollaboration')}
        </Text>
        <Image src={EventPreview} alt="Event preview" />
      </Flex>
      <Flex textAlign="center" flexDirection="column" maxW="1000px" margin="auto">
        <Text mt={8}>{t('newEventPage.collaborationDescription')}</Text>
        <Flex flexDirection={{ base: 'column', lg: 'row' }} gap={6} mt={12}>
          <Flex textAlign="left" flexDirection="column" flex={1}>
            <Text fontFamily="heading" fontSize="3xl">
              {t('newEventPage.turnYourConference')}
              <Text fontFamily="heading" as="span" fontWeight="bold">
                {t('newEventPage.revenueGeneratingPlatform')}
              </Text>
            </Text>
            <Text mt={6}>{t('newEventPage.goldenOpportunity')}</Text>
            <Text mt={4}>{t('newEventPage.salesVirtuosos')}</Text>
          </Flex>
          <Box flex={1}>
            <Image style={{ width: '100%' }} src={BigScreenEvent} alt="Event preview" />
          </Box>
        </Flex>
        <RedCardWithDownloadButton
          slug="twelve-revenue"
          smallHeading={t('newEventPage.downloadCardTwo.smallTitle')}
          heading={t('newEventPage.downloadCardTwo.title')}
        />
      </Flex>
    </Container>
  );
};
